import { Account } from 'types/common/account';
import { create } from 'zustand';

type AccountProps = {
  accountId: string;
  setAccountId: (accountId: string) => void;

  account: Account | null;
  setAccount: (accountInfo: Account | null) => void;
};

const useAccountStore = create<AccountProps>((set, get) => ({
  accountId: '',
  setAccountId: (accountId: string) => set(() => ({ accountId })),

  account: null,
  setAccount: (account: Account | null) => set(() => ({ account })),
}));

export default useAccountStore;
